export class GenericDomainError extends Error {
    // TODO: Investigate a way to simplify domain error handling. #286495
    constructor(errorCode, errorCodeDescription, errorData, ...params) {
        super(...params);
        this.errorCode = errorCode;
        this.errorCodeDescription = errorCodeDescription;
        this.errorData = errorData;
        if (params.length === 0) {
            this.message = errorCodeDescription;
        }
        Object.setPrototypeOf(this, GenericDomainError.prototype);
    }
}
